<template>
  <div
    class="project-card"
    :class="{ 'inactive': isInactive }"
    @click="project.goTo('cabinet')"
  >
    <div class="project-main">
      <div class="project-logo">
        <project-logo :project="project" size="lg" />
      </div>
      <div class="project-name" :title="project.name">{{ project.name }}</div>
      <a :href="project.link" class="project-link" target="_blank">{{ formattedLink }}</a>
    </div>
    <div class="project-info">
      <div class="project-info-point">
        <span class="project-info-name">{{ $t('common.balance') }}</span>
        <span>{{ displayBalance }}</span>
      </div>
      <div class="project-info-point">
        <span class="project-info-name">{{ $t('average.check') }}</span>
        <span>{{ displayAvgAmount }}</span>
      </div>
      <div class="project-info-point">
        <span class="project-info-name">{{ $t('payments.in.day') }}</span>
        <span>{{ project.paymentsPerDay }}</span>
      </div>
    </div>
    <div class="project-actions">
      <div class="project-action" @click.stop="project.shownQrCode()">
        <span class="icon qr-code"></span>
      </div>
      <div class="project-action" @click.stop="onRouteToInvoicing">
        <span class="icon plus"></span>
      </div>
      <div class="project-action" @click.stop="onRouteToPayout">
        <span class="icon withdrawals"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatAmount } from 'lib/utils/amount';

import ProjectLogo from 'molecules/project/ProjectLogo';

import { INVOICING, PAYOUT } from '@/router/const';

// eslint-disable-next-line no-useless-escape
const PROTOCOL_REGEX = /^(http(s?))\:\/\//i;

export default {
  name: 'ProjectCard',
  components: {
    ProjectLogo,
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isInactive() {
      return this.project.isInactive;
    },
    formattedLink() {
      return this.project?.link?.replace(PROTOCOL_REGEX, '') ?? '';
    },
    displayBalance() {
      return formatAmount(this.project.balance, this.project.currency);
    },
    displayAvgAmount() {
      return formatAmount(this.project.avgAmount, this.project.currency);
    },
  },
  methods: {
    onRouteToInvoicing() {
      this.project.goTo(INVOICING);
    },
    onRouteToPayout() {
      this.project.goTo(PAYOUT);
    },
  },
};
</script>

<style lang="sass" scoped>
  @import 'src/containers/app/pages/projects/components/project-card'
</style>
